export interface CollectionResponse<Resource> {
  total: number;
  pages: number;
  page: number;
  results: Resource[];
}

export function arrayFromCollection<T>(collection: CollectionResponse<T>): T[] {
  return collection.results;
}